function restoreSpacesInText(text) {
  return text.replace(/-/g, ' ');
}

export default restoreSpacesInText;